/**
 * hook de analise de risco TCU pra um item.
 *
 * 422 (cesta nao formada) e estado valido — UI nao mostra a secao.
 */

import { useQuery } from '@tanstack/react-query';
import type { AnaliseRiscoResponse } from '@licita-mind/shared-types';
import { ApiError, apiFetch } from '../lib/api';

export const useAnaliseRisco = (itemId: string | undefined) =>
  useQuery({
    queryKey: ['analise-risco', itemId],
    queryFn: async () => {
      try {
        return await apiFetch<AnaliseRiscoResponse>(`/v1/itens/${itemId}/analise-risco`);
      } catch (e) {
        if (e instanceof ApiError && e.status === 422) return null;
        throw e;
      }
    },
    enabled: !!itemId,
    staleTime: 15_000,
  });
